import React from 'react';
import { useInView } from 'react-intersection-observer';
import {
  HiCube,
  HiChip,
  HiDatabase,
  HiCloud,
  HiShieldCheck,
  HiLightningBolt,
} from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Solutions.css';

const Solutions = () => {
  const { t } = useLanguage();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const solutionCopy = t('solutions.items');
  const solutionsData = [
    { key: 'platform', icon: <HiDatabase />, highlight: true },
    { key: 'language', icon: <HiChip /> },
    { key: 'vision', icon: <HiCube /> },
    { key: 'automation', icon: <HiLightningBolt /> },
    { key: 'deployment', icon: <HiCloud /> },
    { key: 'responsible', icon: <HiShieldCheck /> },
  ].map((item) => ({
    ...item,
    ...solutionCopy[item.key],
  }));

  return (
    <section className="solutions" id="solutions" ref={ref}>
      <div className="solutions__container">
        <div className="solutions__header">
          <span className="solutions__eyebrow">{t('solutions.eyebrow')}</span>
          <h2 className="solutions__title">{t('solutions.title')}</h2>
          <p className="solutions__subtitle">
            {t('solutions.subtitle')}
          </p>
        </div>

        <div className={`solutions__grid ${inView ? 'solutions__grid--visible' : ''}`}>
          {solutionsData.map((solution, index) => (
            <div
              key={index}
              className={`solutions__card ${solution.highlight ? 'solutions__card--highlight' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="solutions__card-icon">{solution.icon}</div>
              <h3 className="solutions__card-title">{solution.title}</h3>
              <p className="solutions__card-description">{solution.description}</p>
              <div className="solutions__card-tags">
                {solution.tags.map((tag, i) => (
                  <span key={i} className="solutions__tag">{tag}</span>
                ))}
              </div>
              <div className="solutions__card-line"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
